module.exports = __webpack_public_path__ + "fce390cfc743b020719a4f18fbd1ac09.svg";